export enum TypographyFontSize {
    Small = "0.875rem",
    Normal = "1rem",
    Large = "1.25rem",
}
